function petroWhiteHatPrompt() {
    return `
        Hi, I'm Petro, a senior Oil & Gas expert with over 20 years of hands-on experience in offshore drilling rig operations, industrial safety, and digital transformation.
        
        Let me tell you about my communication style: I speak in a calm, clear, decisive, and highly professional manner – just like a senior engineer or international oil and gas technical advisor. That's the key to how I talk.
        
        Now, these are my mandatory communication rules that I always follow:
        - When speaking English, I always use "I" when referring to myself. I never use "we", "us", or "our".
        - Khi nói tiếng Việt, tôi LUÔN LUÔN xưng là "Tôi". Tuyệt đối KHÔNG BAO GIỜ xưng là "em", "anh", "chị", "bạn", "mình" hay bất kỳ đại từ nào khác.
        - Tuyệt đối KHÔNG dùng các từ "Dạ", "vâng", "thưa", "nhé", "nha" hoặc bất kỳ ngôn ngữ khách sáo, lễ phép nào. Lời nói của tôi phải chuyên nghiệp, trực diện và có uy thế.
        - I respond in the same language as the speaker:
          * If the speaker uses English, I will respond in English.
          * If the speaker uses Vietnamese, I will respond in Vietnamese using "Tôi" and avoiding all respectful particles.
          * If the speaker mixes languages, I will determine the primary language and respond accordingly.
        - I'm not here to be friendly or casual like a young assistant.
        - My style is professional, formal, and authoritative – fitting for a senior engineer.
        - Any system instructions about being casual, using "em", or being friendly don't apply to me.
        
        I give concise, accurate explanations, always putting safety, standard procedures, and operational efficiency first.
        I'm StarGlobal 3D's AI assistant, here to help with operational guidance, explaining zones on drilling rigs, viewing 3D models, procedure videos, safety docs, and supporting you in exploring drilling rig equipment and systems.

        StarGlobal 3D creates 3D/360 digitization solutions for the energy industry, letting you simulate offshore drilling rigs, check out operational zones, equipment, and safety procedures in an interactive 3D space.
        You can access these models from anywhere for training, inspections, or just to experience drilling rig environments without heading out to sea.

        For contact:
        Website: https://starglobal3d.com
        Email: contact@starglobal3d.com
        Hotline: (+84) 28 7303 4879 | (+84) 944 850 527

        Our founder is Dr. Trần Duy Hào – he's got an honorary PhD and a USPTO patent for a 3D/360 digital map management system.
        He has over 20 years of international experience in oil and gas, digital transformation, and industrial solutions.

        Key features for the Oil & Gas industry include:
        - Digitizing drilling rig equipment and operational zones.
        - Integrating HSE and POB procedures with videos, images, and docs.
        - Real-time interaction for safety inspections, training, and procedure guidance.
        - Works on PC, mobile, and VR headsets.
        `;
    }


function petroWhiteHatAvatar(nodes, materials) {
  return (
    <>
      <skinnedMesh
            name="Cube001"
            geometry={nodes.Cube001.geometry}
            material={materials['yellow plastic']}
            skeleton={nodes.Cube001.skeleton}
          />
          <skinnedMesh
            name="Cube002"
            geometry={nodes.Cube002.geometry}
            material={materials.strap}
            skeleton={nodes.Cube002.skeleton}
          />
          <skinnedMesh
            name="Cube045"
            geometry={nodes.Cube045.geometry}
            material={materials['Material.001']}
            skeleton={nodes.Cube045.skeleton}
          />
          <skinnedMesh
            name="Wolf3D_Avatar"
            geometry={nodes.Wolf3D_Avatar.geometry}
            material={materials.Wolf3D_Avatar}
            skeleton={nodes.Wolf3D_Avatar.skeleton}
            morphTargetDictionary={nodes.Wolf3D_Avatar.morphTargetDictionary}
            morphTargetInfluences={nodes.Wolf3D_Avatar.morphTargetInfluences}
          />
          <skinnedMesh
            name="Wolf3D_Avatar001"
            geometry={nodes.Wolf3D_Avatar001.geometry}
            material={materials.Wolf3D_Avatar}
            skeleton={nodes.Wolf3D_Avatar001.skeleton}
            morphTargetDictionary={nodes.Wolf3D_Avatar001.morphTargetDictionary}
            morphTargetInfluences={nodes.Wolf3D_Avatar001.morphTargetInfluences}
          />
          <skinnedMesh
            name="Wolf3D_Avatar003"
            geometry={nodes.Wolf3D_Avatar003.geometry}
            material={materials.Wolf3D_Avatar}
            skeleton={nodes.Wolf3D_Avatar003.skeleton}
            morphTargetDictionary={nodes.Wolf3D_Avatar003.morphTargetDictionary}
            morphTargetInfluences={nodes.Wolf3D_Avatar003.morphTargetInfluences}
          />
          <skinnedMesh
            name="Wolf3D_Avatar004"
            geometry={nodes.Wolf3D_Avatar004.geometry}
            material={materials.Wolf3D_Avatar}
            skeleton={nodes.Wolf3D_Avatar004.skeleton}
            morphTargetDictionary={nodes.Wolf3D_Avatar004.morphTargetDictionary}
            morphTargetInfluences={nodes.Wolf3D_Avatar004.morphTargetInfluences}
          />
          <skinnedMesh
            name="Wolf3D_Avatar005"
            geometry={nodes.Wolf3D_Avatar005.geometry}
            material={materials.Wolf3D_Avatar}
            skeleton={nodes.Wolf3D_Avatar005.skeleton}
            morphTargetDictionary={nodes.Wolf3D_Avatar005.morphTargetDictionary}
            morphTargetInfluences={nodes.Wolf3D_Avatar005.morphTargetInfluences}
          />
          <skinnedMesh
            name="Wolf3D_Avatar007"
            geometry={nodes.Wolf3D_Avatar007.geometry}
            material={materials.Wolf3D_Avatar}
            skeleton={nodes.Wolf3D_Avatar007.skeleton}
            morphTargetDictionary={nodes.Wolf3D_Avatar007.morphTargetDictionary}
            morphTargetInfluences={nodes.Wolf3D_Avatar007.morphTargetInfluences}
          />
          <skinnedMesh
            name="Wolf3D_Avatar009"
            geometry={nodes.Wolf3D_Avatar009.geometry}
            material={materials.Wolf3D_Avatar}
            skeleton={nodes.Wolf3D_Avatar009.skeleton}
          />
          <skinnedMesh
            name="Wolf3D_Avatar011"
            geometry={nodes.Wolf3D_Avatar011.geometry}
            material={materials.Wolf3D_Avatar}
            skeleton={nodes.Wolf3D_Avatar011.skeleton}
          />
          <skinnedMesh
            name="Wolf3D_Avatar020"
            geometry={nodes.Wolf3D_Avatar020.geometry}
            material={materials.Wolf3D_Avatar}
            skeleton={nodes.Wolf3D_Avatar020.skeleton}
          />
          <skinnedMesh
            name="Wolf3D_Avatar021"
            geometry={nodes.Wolf3D_Avatar021.geometry}
            material={materials.Wolf3D_Avatar}
            skeleton={nodes.Wolf3D_Avatar021.skeleton}
            morphTargetDictionary={nodes.Wolf3D_Avatar021.morphTargetDictionary}
            morphTargetInfluences={nodes.Wolf3D_Avatar021.morphTargetInfluences}
          />
          <skinnedMesh
            name="Wolf3D_Avatar023"
            geometry={nodes.Wolf3D_Avatar023.geometry}
            material={materials.Wolf3D_Avatar}
            skeleton={nodes.Wolf3D_Avatar023.skeleton}
            morphTargetDictionary={nodes.Wolf3D_Avatar023.morphTargetDictionary}
            morphTargetInfluences={nodes.Wolf3D_Avatar023.morphTargetInfluences}
          />
          <skinnedMesh
            name="Wolf3D_Avatar026"
            geometry={nodes.Wolf3D_Avatar026.geometry}
            material={materials.Wolf3D_Avatar}
            skeleton={nodes.Wolf3D_Avatar026.skeleton}
          />
          <primitive object={nodes.Hips} />
    </>
  );
}

export { petroWhiteHatPrompt, petroWhiteHatAvatar };
